module.exports = __webpack_public_path__ + "img/centro4.297eca39.jpg";